import React from 'react';
import { CameraIcon } from 'lucide-react';
const events = [{
  title: 'Q1 All-Hands',
  date: 'March 2025',
  photos: ['https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=400&h=300&fit=crop', 'https://images.unsplash.com/photo-1511578314322-379afb476865?w=400&h=300&fit=crop', 'https://images.unsplash.com/photo-1529543544282-ea99407407c1?w=400&h=300&fit=crop']
}, {
  title: '$1B Milestone Celebration',
  date: 'February 2025',
  photos: ['https://images.unsplash.com/photo-1517457373958-b7bdd4587205?w=400&h=300&fit=crop', 'https://images.unsplash.com/photo-1505373877841-8d25f7d46678?w=400&h=300&fit=crop', 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=400&h=300&fit=crop', 'https://images.unsplash.com/photo-1523580494863-6f3031224c94?w=400&h=300&fit=crop']
}, {
  title: 'Q4 2024 Holiday Party',
  date: 'December 2024',
  photos: ['https://images.unsplash.com/photo-1559223607-a43c990c692c?w=400&h=300&fit=crop', 'https://images.unsplash.com/photo-1527529482837-4698179dc6ce?w=400&h=300&fit=crop', 'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=400&h=300&fit=crop', 'https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?w=400&h=300&fit=crop']
}, {
  title: 'Team Building Day',
  date: 'November 2024',
  photos: ['https://images.unsplash.com/photo-1501281668745-f7f57925c3b4?w=400&h=300&fit=crop', 'https://images.unsplash.com/photo-1519671482749-fd09be7ccebf?w=400&h=300&fit=crop', 'https://images.unsplash.com/photo-1528605248644-14dd04022da1?w=400&h=300&fit=crop', 'https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=400&h=300&fit=crop']
}];
export function EventPhotos() {
  return <div style={{
    maxWidth: 1280,
    margin: '0 auto'
  }} data-id="element-296">
      <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: 12,
      marginBottom: 32
    }} data-id="element-297">
        <div style={{
        width: 48,
        height: 48,
        borderRadius: 12,
        background: '#EBF5FB',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }} data-id="element-298">
          <CameraIcon size={24} color="#2B8DC4" data-id="element-299" />
        </div>
        <div data-id="element-300">
          <h2 style={{
          fontSize: 26,
          fontWeight: 900,
          color: '#1A2B3C',
          margin: '0 0 3px',
          fontStyle: 'italic',
          letterSpacing: '-0.04em'
        }} data-id="element-301">
            Event Photos
          </h2>
          <p style={{
          fontSize: 13,
          color: '#5A6A8A',
          margin: 0
        }} data-id="element-302">
            Memories from Swift events and celebrations
          </p>
        </div>
      </div>

      <div style={{
      display: 'flex',
      flexDirection: 'column',
      gap: 40
    }} data-id="element-303">
        {events.map((event, i) => <div key={i} data-id="element-304">
            <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          marginBottom: 16
        }} data-id="element-305">
              <h3 style={{
            fontSize: 18,
            fontWeight: 900,
            color: '#1A2B3C',
            margin: 0,
            fontStyle: 'italic',
            letterSpacing: '-0.02em'
          }} data-id="element-306">
                {event.title}
              </h3>
              <span style={{
            fontSize: 11,
            fontWeight: 800,
            padding: '2px 8px',
            borderRadius: 4,
            background: '#E4EAF6',
            color: '#5A6A8A'
          }} data-id="element-307">
                {event.date}
              </span>
            </div>
            <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
          gap: 16
        }} data-id="element-308">
              {event.photos.map((photo, j) => <div key={j} style={{
            borderRadius: 12,
            overflow: 'hidden',
            border: '1px solid #E4EAF6',
            boxShadow: '0 2px 8px rgba(13,27,42,0.06)',
            aspectRatio: '4/3',
            cursor: 'pointer'
          }} data-id="element-309">
                  <img src={photo} alt={`${event.title} photo ${j + 1}`} style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              transition: 'transform 0.3s ease'
            }} onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.05)'} onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'} data-id="element-310" />
                </div>)}
            </div>
          </div>)}
      </div>
    </div>;
}